import React from 'react';
import { FaHeart } from 'react-icons/fa';
import styled from 'styled-components';

const HeartButton = styled.button`
  background: ${props => (props.favorited ? '#ff0000' : 'none')};
  border: none;
  outline: none;
  cursor: pointer;
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 2;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  color: ${props => (props.favorited ? '#ffffff' : '#fff')};
  font-size: 22px;
  transition: all 0.2s;
  filter: drop-shadow(0 1px 3px rgba(0,0,0,0.18));

  &:hover {
    background: #ff0000;
    color: #ffffff;
    transform: scale(1.15);
  }
`;

export default function FavoriteHeart({ favorited, onClick }) {
  return (
    <HeartButton favorited={favorited} onClick={onClick} aria-label={favorited ? 'Remover dos favoritos' : 'Adicionar aos favoritos'}>
      <FaHeart />
    </HeartButton>
  );
}
